module.exports = __webpack_public_path__ + "img/MisionVF.1bcedffd.jpg";